module.exports = {
  headSection: 'Your Product Rating',
  rating: '*Overall Rating',
  value: 'Value',
  quality: 'Quality',
  recommend: 'Votre évaluation de produit',
};
